export const COLOR_THEME = {
    heading: '#516679',
    active: '#2FCEA8',
}
